module.exports = __webpack_public_path__ + "img/csomagjaink_bg_1920.3c3c0de6.png";